import { request } from '@vtx/utils';

const url = '/cloud/jcss-reborn/facility';

export const getInfo = async id => {
    const res = await request.get(`${url}/get`, {
        data: { id, coordType: 'bd09' },
    });
    if (res?.result === 0) {
        return res?.data;
    }
    return {};
};

export const getFieIds = async () => {
    const res = await request.get(`${url}/type/view/detail`, {
        data: { code: 'gas_cz' },
    });
    if (res?.result === 0) {
        return res?.data?.customFields;
    }
    return [];
};
